<!-- 
<div class="action-container">
  <div>
    <br/>
    <br/>
    <nz-input-group style="min-width: 350px;" nzSearch [nzAddOnAfter]="suffixIconButton">
      <input type="text" nz-input placeholder="search ..." />
    </nz-input-group>
    <ng-template #suffixIconButton>
      <button nz-button nzType="primary" nzSearch><nz-icon nzType="search" /></button>
    </ng-template>
  </div>
  
    <br/>
  </div>
      <nz-table #userTable nzBordered [nzLoading]="loading"  nzOuterBordered nzSize="middle"  [nzData]="listOfData">
        <thead>
          <tr>
            <th nzWidth="10%">No.</th>
            <th nzWidth="30%">User Name</th>
            <th>Mobile No.</th>
            <th>Location</th>
            <th>Email</th>
            <th>Status</th>
            <th><button nz-tooltip nz-button nzTooltipTitle="Add User"  nzPrimary (click)="addUser()">
              <nz-icon nzType="plus-circle" nzTheme="outline" />
            </button></th>
          </tr>
        </thead>
        <tbody>
          @for (data of listOfData; track data;let i = $index) {
            <tr>
              <td>{{i+1}}</td>
              <td>
                {{ data.name }}
              </td>
              <td>{{ data.phone }}</td>
              <td>
                {{ data.location }}
              </td>
              <td>
                {{ data.email }}
              </td>
              <td>
                {{ data.status }}
              </td>
              <td>
                <button nz-tooltip nz-button nzTooltipTitle="Edit User"  nzPrimary (click)="edit(i)">
                  <nz-icon nzType="edit" nzTheme="twotone" />
                </button>
                <nz-divider nzType="vertical"></nz-divider>
                <button nz-tooltip nz-button nzTooltipTitle="Delete User"  nzDanger >
                  <nz-icon nzType="delete" style="color: #ff4d4f;" nzTheme="fill" />
                </button>
              </td>
            </tr>
          }
        </tbody>
      </nz-table>
   -->


<app-dynamic-table [schema]="schema" [modalfieldConfig]="fieldConfig" [total]="total" [data]="list" (changeEvent)="change($event)" (actionEvent)="formEvent($event)"></app-dynamic-table>